export default __webpack_public_path__ + "static/media/UFInfo.77b519a0.md";